module.exports = __webpack_public_path__ + "static/media/61.39b3e502.png";